import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import * as Analytics from 'analytics/Analytics';
import {AnalyticsMetadataForContext} from 'analytics/AnalyticsTypes';
import {ANALYTICS_MODULE, COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import {FONT_PROXIMA_13} from 'styles/FontConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import useOnMount from 'ui-library/hooks/useOnMount';
import Modal from 'ui-library/modals/Modal';

interface ContextualTemplateEditingBetaModalProps {
  releaseValue: string;
  analyticsMetadata: AnalyticsMetadataForContext;
  analyticsModule: ANALYTICS_MODULE;
  onRequestSubmit: () => void;
  onRequestClose: () => void;
}

export default function ContextualTemplateEditingBetaModal({
  releaseValue,
  analyticsMetadata,
  analyticsModule,
  onRequestSubmit,
  onRequestClose,
}: ContextualTemplateEditingBetaModalProps): JSX.Element {
  useOnMount(() => {
    Analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, analyticsModule, analyticsMetadata);
  });

  const handleOptIn = (): void => {
    Analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.SUBMITTED_BETA_REQUEST, analyticsModule, {
      ...analyticsMetadata,
      release: releaseValue,
    });
    onRequestSubmit();
  };

  return (
    <Modal
      title="Request beta access"
      onRequestSubmit={handleOptIn}
      onRequestClose={onRequestClose}
      buttons={[{submit: true, text: 'Send Request', style: ButtonStyle.PRIMARY}]}
    >
      <div className={css(styles.text)}>
        Click "Send Request" to send a message to our Customer Support Team.
      </div>
      <div className={css(styles.text)}>
        Look for an e-mail with more detailed information on this beta in the next 24 hours. Just read it and
        reply to complete the sign-up process!
      </div>
    </Modal>
  );
}

const styles = StyleSheet.create({
  text: {
    ...FONT_PROXIMA_13,
  },
});
